import httpClient from '../utils/httpClient';

export const getETFPriceChart = async (
  cocode: string,
  exchange: string,
  period: string,
) => httpClient.get(`/api/v1/etf/chart/${exchange}/${cocode}/${period}`);
